function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLoaderOval = function SvgLoaderOval(props) {
  return React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75"
  }, props), React.createElement("path", {
    style: {
      backgroundImage: "conic-gradient(#ade5ff 73%,#1ab6ff 58%,#ade5ff 73%)"
    },
    d: "M2.884 22.454a2 2 0 113.695 1.532A33.89 33.89 0 004 37c0 18.778 15.222 34 34 34s34-15.222 34-34S56.778 2 38 2c-1.105 0-2 .105-2-1s.895-1 2-1c20.987 0 38 16.013 38 37S58.987 75 38 75 0 57.987 0 37c0-5.054.988-9.974 2.884-14.546z",
    opacity: 0.92
  }));
};

export default __webpack_public_path__ + "static/media/loader-oval.e079b693.svg";
export { SvgLoaderOval as ReactComponent };